import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AvailableDevicesActions } from "@states/available-devices/available-devices.action-type";
import { catchError, switchMap } from "rxjs";
import { UtilsService } from "src/app/edge/utils.service";
import { EdgeServiceV2 } from "src/app/services/edge.service";

@Injectable()
export class AvailableDevicesEffect {
    public getAvailableDevices$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(AvailableDevicesActions.getAvailableDevices),
            switchMap(() => {
                return this.edgeServiceV2.getAvailableCores().pipe(
                    switchMap(devices => {
                        return [
                            AvailableDevicesActions.getAvailableDevicesSuccess({ availableDevices: devices }),
                        ]
                    }),
                    catchError((response) => {
                        console.error(this.utilsService.errMessage(response));

                        return [
                            AvailableDevicesActions.getAvailableDevicesFail(),
                        ]
                    })
                )
            }),
        );
    });

    constructor(
        private actions$: Actions,
        private utilsService: UtilsService,
        private edgeServiceV2: EdgeServiceV2,
    ) { }
};


